import client from "./client";
export const getNotifications = () => client.get("/notifications");
export const markAllRead = () => client.put("/notifications/read-all");
export const markOneRead = (id) => client.put(`/notifications/${id}/read`);
export const markOneUnread = (id) => client.put(`/notifications/${id}/unread`);
export const markCategoryRead = (types) => client.put("/notifications/read-category", { types });
export const deleteNotification = (id) => client.delete(`/notifications/${id}`);
export const deleteAllNotifications = () => client.delete("/notifications/all");
export const getNotificationPreferences = () => client.get("/notifications/preferences");
export const updateNotificationPreference = (notificationType, inApp, email) =>
  client.put("/notifications/preferences", { notificationType, inApp, email });
